export default "__VITE_ASSET__CdTW$1ZG__"